import { FunctionComponent, memo } from 'react';
import { useTranslation } from 'react-i18next';
import Skeleton from 'react-loading-skeleton';
import {
  AudioBlockData,
  AudioPlayerTrigger,
  FileStatus,
  ImageGallery,
  ImageGalleryItem,
  MediaBlockUploadPreview,
} from '../../../../shared';

import classes from './Audio.module.scss';

interface AudioProps extends AudioBlockData {
  storyId?: number;
  cardId?: number;
  chatId?: number;
  blockId?: string;
  cardTitle?: string;
}

export const Audio: FunctionComponent<AudioProps> = memo(
  ({ items, storyId, cardId, chatId, blockId, cardTitle }) => {
    const { t } = useTranslation();

    if (!items.length) {
      return null;
    }

    const { audio, previewUrl, caption, copyright } = items[0];

    if (!audio) {
      return null;
    }

    const { url, status } = audio;

    if (status === FileStatus.PROCESSING) {
      return <Skeleton height={'3rem'} />;
    }

    if (!url) {
      return (
        <MediaBlockUploadPreview iconId={'audio'} label={t('richTextEditor.audio-placeholder')} />
      );
    }

    const imageGalleryItems: ImageGalleryItem[] = [
      { image: { url: previewUrl ?? '', rightholder: copyright ?? '' } },
    ];

    return (
      <div className={classes['audio']}>
        <ImageGallery items={imageGalleryItems} singleImageFullSize modalPreviewOnClick />
        <AudioPlayerTrigger
          storyId={storyId ?? 0}
          cardId={cardId ?? 0}
          chatId={chatId}
          blockId={blockId}
          cardTitle={cardTitle ?? ''}
          src={audio.url}
        />
        {caption && <div className={classes['audio__caption']}>{caption}</div>}
      </div>
    );
  }
);
